import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalDIOperations = ({
  show,
  onHide,
  onSelect,
  isSBOItemDisabled,
  isDOItemDisabled,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = () => {
    if (selectedOption) {
      onSelect(selectedOption); // Send selected option to parent
      onHide(); // Hide the modal
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select an Option</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
      >
        <div>
          <label aria-disabled={isSBOItemDisabled}>
            <input
              type="radio"
              name="radioGroup"
              disabled={isSBOItemDisabled}
              value="Select Before Operate"
              onChange={handleOptionChange}
            />
            Select Before Operate
          </label>
        </div>
        <div>
          <label aria-disabled={isDOItemDisabled}>
            <input
              type="radio"
              name="radioGroup"
              disabled={isDOItemDisabled}
              value="Direct Operate Asset"
              onChange={handleOptionChange}
            />
            Direct Operate Asset
          </label>
        </div>

        <div>
          <label>
            <input
              type="radio"
              name="radioGroup"
              value="See Details"
              onChange={handleOptionChange}
            />
            See Details
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!selectedOption}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDIOperations;
